import React from 'react';
import './LegalPages.css';

function TermsOfService({ onBack }) {
  return (
    <section className="legal-page">
      <div className="legal-container">
        <button className="back-button" onClick={onBack}>← Back</button>
        
        <h1>Terms of Service</h1>
        <p><strong>Last Updated: April 2026</strong></p>

        <h2>1. Agreement to Terms</h2>
        <p>
          By accessing and using this website operated by Northstar Bridge Commerce LLC, 
          you agree to be bound by these terms and conditions.
        </p>

        <h2>2. Use License</h2>
        <p>
          Permission is granted to temporarily download one copy of the materials on our website 
          for personal, non-commercial transitory viewing only. This license does not include:
        </p>
        <ul>
          <li>Reproduction or copying for resale or commercial purposes</li>
          <li>Modification of any materials</li>
          <li>Removal of any proprietary notices or labels</li>
          <li>Transferring materials to another person or server</li>
        </ul>

        <h2>3. Disclaimer</h2>
        <p>
          The materials on our website are provided on an "as-is" basis without warranties of any kind, 
          either express or implied. We disclaim all warranties including fitness for a particular purpose.
        </p>

        <h2>4. Limitations of Liability</h2>
        <p>
          In no event shall Northstar Bridge Commerce LLC be liable for damages arising out of 
          or in connection with your use of this website.
        </p>

        <h2>5. Accuracy of Materials</h2>
        <p>
          We do not warrant that the materials on our website are accurate, complete, or current. 
          We may make changes to these materials at any time.
        </p>

        <h2>6. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not responsible for 
          the content, accuracy, or practices of external sites.
        </p>

        <h2>7. Modifications</h2>
        <p>
          We reserve the right to modify these terms at any time. Your continued use of the website 
          following changes constitutes acceptance of the updated terms.
        </p>

        <h2>8. Governing Law</h2>
        <p>
          These terms and conditions are governed by the laws of Delaware, United States. 
          Any disputes shall be subject to the exclusive jurisdiction of Delaware courts.
        </p>

        <h2>9. Contact Information</h2>
        <p>
          For questions regarding these terms, contact:<br />
          <strong>Northstar Bridge Commerce LLC</strong><br />
          Email: <a href="mailto:sales@northstarbridgeco.com">sales@northstarbridgeco.com</a><br />
          Phone: <a href="tel:+13023858016">+1 302 385 8016</a>
        </p>
      </div>
    </section>
  );
}

export default TermsOfService;
